import React from 'react';
import { components } from '@glowforge/ui-common';
import NavigationItem from './navigation/navigation-item';

import './global-footer.less';

const { Footer } = components;

const GlobalFooter = ({
  globalFooterLinks,
  globalFooterLogo,
  globalFooterCopyright,
  globalFooterAddress,
}) => (
  <Footer
    NavigationItem={NavigationItem}
    globalFooterLinks={globalFooterLinks}
    globalFooterLogo={globalFooterLogo}
    globalFooterCopyright={globalFooterCopyright}
    globalFooterAddress={globalFooterAddress} />
);

GlobalFooter.propTypes = Footer.propTypes;

export default GlobalFooter;



// WEBPACK FOOTER //
// ./app/common/components/global-footer.jsx